import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { LearnerWalletHistory } from "../../redux/actions/UserAction";
import Loder from "../../components/loder";
import { downcounter, getDate } from "../../helpers/TimeDate";
import { currencyConverter } from "../../helpers/planPrice";
import { initGA, initPixel } from "../../helpers/CampaignEvents";
import Countdown from "react-countdown";

const currency = JSON.parse(localStorage.getItem("CURRENCY"));

const LearnerWalletNew = () => {
  const dispatch = useDispatch();
  const User = useSelector((state) => state.UserReducer.user);
  const walletHistory = useSelector(
    (state) => state.UserReducer.learnerWalletHistory
  );

  const [walletMoney, setWalletMoney] = useState(0);

  useEffect(() => {
    initPixel()
    initGA()
  }, [])

  useEffect(() => {
    dispatch(LearnerWalletHistory({ learnerId: User._id }));
  }, [User]);

  useEffect(() => {
    if (walletHistory) {
      walletHistory.slice(0, 1).map((data) => {
        setWalletMoney(data.closingBalance);
      });
    }
  });

  console.log(walletHistory)

  const secondConverter = (weekexp) => {
    var now = new Date().getTime();
    var mydate = new Date(weekexp).getTime();
    return mydate - now;
  };

  // countdown timer
  const renderer = ({ days, hours, minutes, seconds }) => {
    return (
      <span>
        {days} Days {hours} hours {minutes} minutes:{seconds} seconds
      </span>
    );

  };

  return (
    <div className="wallet pt-2 pb-4">
      {/* <hr className="line" /> */}
      <div className="content">
        
        <div className="card mx-auto">
          <div className="card-body">
            <h3 className="text-center mt-5 pt-2">Current balance:</h3>
            <h2 className="text-center mt-3"> {currency?currencyConverter((walletMoney/currency).toFixed(2)):`₹ ${walletMoney.toFixed(2)}`}</h2>
            <hr />
            <p className="title">History</p>
            <div className="row container">
              {walletHistory ? (
                walletHistory[0] ? (
                  walletHistory.map((data, i) => (
                    <div
                      className="col-md-4 col-12 small_Card m-2 pl-0 "
                      key={i}
                    >
                   
                      <div className="d-flex pt-2">
                        <div>
                          <p className="money mb-0">
                            {data.txnType == "I" ? "+" : ""}{currency?currencyConverter((data.amount/currency).toFixed(2)):`₹ ${data.amount.toFixed(2)}`}
                          </p>

                          <p
                            className={`refer ${
                              data.txnType == "I"
                                ? "text-success"
                                : "text-danger"
                            }`}
                          >
                            {data.txnDesc}
                          </p>
                        </div>
                        <div>
                          <p className="date">{getDate(data.createdAt)}</p>

                          <p className="text-danger date " id="countdown">
                            {data.expiryDate && data.txnType == "I"
                              ? <Countdown
                              date={
                                Date.now() +
                                secondConverter(
                                  data.expiryDate
                                )
  
                              }
                              renderer={renderer}
                            />
                              : downcounter(new Date())}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center col-12 mt-4 mb-4">
                    Your wallet is empty
                  </div>
                )
              ) : (
                <div className="text-center col-12 mt-4 mb-4">
                  <Loder />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearnerWalletNew;
